import React, { useState } from 'react';
import { Card, Upload, Button, message, Space, Typography } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import type { UploadFile, UploadProps } from 'antd';
import { apiCrmImportApollo } from '../../services/api/crm';
import { selectUserState } from '../../store/selectors/user';
import { useSelector } from 'react-redux';

const { Title, Text } = Typography;

export default function CRMPage() {
  const [uploading, setUploading] = useState(false);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const { token } = useSelector(selectUserState);

  const handleUpload = async () => {
    if (fileList.length === 0) {
      message.error('Please select a CSV file first');
      return;
    }

    if (!token) {
      message.error('Authentication required');
      return;
    }

    const file = fileList[0] as any;
    console.log(fileList);
    setUploading(true);

    try {
      const [response, status] = await apiCrmImportApollo(file, token);

      if (status === 201 && response.success) {
        message.success(
          `Imported (${response.companies || 0} companies, ${
            response.people || 0
          } people)`,
        );
        setFileList([]);
      } else {
        message.error(response.message || 'Import failed');
      }
    } catch (error) {
      message.error('An error occurred during import');
      console.error('Import error:', error);
    } finally {
      setUploading(false);
    }
  };

  const uploadProps: UploadProps = {
    fileList,
    beforeUpload: (file) => {
      const isCsv = file.type === 'text/csv' || file.name.endsWith('.csv');
      if (!isCsv) {
        message.error('You can only upload CSV files!');
        return false;
      }
      setFileList([file]);
      return false; // Prevent automatic upload
    },
    onRemove: () => {
      setFileList([]);
    },
    maxCount: 1,
  };

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>CRM Management</Title>
      <Button
        size="large"
        href="https://crm.tapform.io"
        target="_blank"
        style={{ marginBottom: '16px' }}
        type="primary"
      >
        Go to CRM
      </Button>
      <Card title="Apollo Contact Import" style={{ marginTop: '16px' }}>
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <Text type="secondary">
            Upload a CSV file containing Apollo contact data to import into your
            CRM.
          </Text>

          <Upload {...uploadProps}>
            <Button icon={<UploadOutlined />}>Select CSV File</Button>
          </Upload>

          <Button
            type="primary"
            onClick={handleUpload}
            disabled={fileList.length === 0}
            loading={uploading}
          >
            {uploading ? 'Importing...' : 'Import Contacts'}
          </Button>
        </Space>
      </Card>
    </div>
  );
}
